/**
 * Soharie custom cursor — gold dot + trailing ring (from prototype).
 * Desktop pointer only; disabled in theme editor and reduced-motion.
 */
(function () {
  var INTERACTIVE =
    'a, button, input:not([type="hidden"]):not([disabled]), select, textarea, summary, [role="button"], [data-mega-menu-trigger], .ccs-stagger-card, .soharie-mega__card, .soharie-mega__close, .soharie-pcard, .product-card, .card-wrapper, .cart-drawer__close-button, label[for]';

  function canUseCustomCursor() {
    if (window.Shopify && window.Shopify.designMode) return false;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
    if (!window.matchMedia('(pointer: fine)').matches) return false;
    return true;
  }

  function init() {
    if (!canUseCustomCursor()) return;

    var root = document.documentElement;
    var cursor = document.getElementById('ccs-cursor');
    var ring = document.getElementById('ccs-cursor-ring');

    if (!cursor || !ring) return;

    root.classList.add('ccs-custom-cursor');

    var mouseX = 0;
    var mouseY = 0;
    var ringX = 0;
    var ringY = 0;
    var hovering = false;
    var rafId = null;
    var activeDialog = null;
    var cursorParent = cursor.parentElement;

    function getActiveDialog() {
      var dialogs = document.querySelectorAll('dialog[open]');
      if (!dialogs.length) return null;
      return dialogs[dialogs.length - 1];
    }

    function getLocalCoords(clientX, clientY, dialog) {
      var rect = dialog.getBoundingClientRect();
      return {
        x: clientX - rect.left,
        y: clientY - rect.top,
      };
    }

    function getDisplayCoords(clientX, clientY) {
      if (activeDialog) {
        return getLocalCoords(clientX, clientY, activeDialog);
      }
      return { x: clientX, y: clientY };
    }

    function ensureCursorLayer(dialog) {
      var layer = dialog.querySelector('.ccs-cursor-layer');
      if (!layer) {
        layer = document.createElement('div');
        layer.className = 'ccs-cursor-layer';
        layer.setAttribute('aria-hidden', 'true');
        dialog.appendChild(layer);
      }
      return layer;
    }

    /** Move cursor into the topmost open dialog (browser top layer). */
    function syncCursorLayer() {
      var openDialog = getActiveDialog();

      if (openDialog) {
        var layer = ensureCursorLayer(openDialog);
        if (cursor.parentElement !== layer) {
          layer.appendChild(cursor);
          layer.appendChild(ring);
        }
        cursor.classList.add('ccs-cursor--dialog');
        ring.classList.add('ccs-cursor-ring--dialog');
        activeDialog = openDialog;
        root.classList.add('ccs-cursor-in-dialog');

        var local = getLocalCoords(mouseX, mouseY, openDialog);
        ringX = local.x;
        ringY = local.y;
        return;
      }

      activeDialog = null;
      cursor.classList.remove('ccs-cursor--dialog');
      ring.classList.remove('ccs-cursor-ring--dialog');

      if (cursor.parentElement !== cursorParent && cursorParent) {
        cursorParent.appendChild(cursor);
        cursorParent.appendChild(ring);
      }

      ringX = mouseX;
      ringY = mouseY;
      root.classList.remove('ccs-cursor-in-dialog');
    }

    function observeDialog(dialog) {
      if (!(dialog instanceof HTMLDialogElement)) return;
      dialogLayerObserver.observe(dialog, { attributes: true, attributeFilter: ['open'] });
    }

    var dialogLayerObserver = new MutationObserver(syncCursorLayer);

    document.querySelectorAll('dialog').forEach(observeDialog);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node instanceof HTMLDialogElement) {
            observeDialog(node);
          } else if (node instanceof Element) {
            node.querySelectorAll('dialog').forEach(observeDialog);
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });

    document.addEventListener('dialog:open', function () {
      syncCursorLayer();
      if (mouseX || mouseY) {
        moveCursor(mouseX, mouseY);
      }
    });

    document.addEventListener('dialog:close', syncCursorLayer);

    syncCursorLayer();

    function setHoverState(active) {
      if (hovering === active) return;
      hovering = active;
      cursor.classList.toggle('is-hovering', active);
      ring.classList.toggle('is-hovering', active);
    }

    function moveCursor(clientX, clientY) {
      mouseX = clientX;
      mouseY = clientY;
      var coords = getDisplayCoords(clientX, clientY);
      cursor.style.left = coords.x - 5 + 'px';
      cursor.style.top = coords.y - 5 + 'px';
      root.classList.add('is-cursor-active');
    }

    function animateRing() {
      var coords = getDisplayCoords(mouseX, mouseY);
      // Lock the ring directly to the cursor (no trailing/following lag)
      ringX = coords.x;
      ringY = coords.y;
      ring.style.left = ringX - 18 + 'px';
      ring.style.top = ringY - 18 + 'px';
      rafId = window.requestAnimationFrame(animateRing);
    }

    document.addEventListener(
      'mousemove',
      function (event) {
        moveCursor(event.clientX, event.clientY);
      },
      { passive: true }
    );

    document.addEventListener(
      'mouseover',
      function (event) {
        setHoverState(!!event.target.closest(INTERACTIVE));
      },
      { passive: true }
    );

    document.addEventListener('mouseleave', function () {
      root.classList.remove('is-cursor-active');
      setHoverState(false);
    });

    document.addEventListener('mousedown', function () {
      cursor.classList.add('is-pressed');
      ring.classList.add('is-pressed');
    });

    document.addEventListener('mouseup', function () {
      cursor.classList.remove('is-pressed');
      ring.classList.remove('is-pressed');
    });

    animateRing();

    window.addEventListener('beforeunload', function () {
      if (rafId) window.cancelAnimationFrame(rafId);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
